import { Suspense, useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import routes from './config/routes/routes';
import { renderRoutes } from './lib/routes/RenderRoutes';
import i18n from './config/i18n';
import { TransportTicketPickerStore } from './store/TransportTicketPickerContext';
import { Types } from './store/transportTicketPickerReducer';
/* import { ContainerProvider } from '@nine7soft/react-di';
import { diConfig } from './config'; */
import './config/i18n';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './lib/ui/theme';
import { visuallyHidden } from '@mui/utils';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useCardSupport } from './views/search/hooks/useCardSupport';

const App: FC = () => {
    const location = useLocation();
    const { state, dispatch } = useContext(TransportTicketPickerStore);
    const [themeState] = useState(theme);
    const { t } = useTranslation();

    useCardSupport();

    useEffect(() => {
        const language = new URLSearchParams(location.search).get('language');
        const transportMode = new URLSearchParams(location.search).get('transportMode');
        dispatch({ type: Types.UpdateLanguage, payload: { language: language || 'fr' } });
        dispatch({ type: Types.UpdateTransportMode, payload: { transportMode: transportMode || 'R' } });
    }, []);

    useEffect(() => {
        i18n.changeLanguage(state.language);
    }, [state]);

    return (
        <>
            <Helmet htmlAttributes={{ lang: state.language }}></Helmet>
            <Box sx={visuallyHidden}>{t('loading')}</Box>

            <ThemeProvider theme={themeState}>
                <Suspense fallback={<></>}>{renderRoutes(routes)}</Suspense>
            </ThemeProvider>

        </>
    );
};

export default App;
